import { FC, Fragment, useCallback, useState } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import {
  ActionButtonsWrapper,
  ActionButton,
  AddLocationButton,
} from '../CustomersSettingsPage.styled';
import { BKJIcon } from '@bookjane2/bookjane-design-library';
import {
  getInitialCreateSubFacilityAddressForm,
  useCustomersSettingsPageFormContext,
} from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/CustomersSettingsPage.form.context';
import { useHistory, useParams } from 'react-router-dom';
import { Flex } from 'components/Flex';
import { DeleteCustomerDialog } from 'pages/Settings/pages/LocationSettings/CustomersSettingsPage/DeleteCustomerDialog/DeleteCustomerDialog';

export const FormActions: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { locationId } = useParams<{ locationId: string; customerId: string }>();
  const { isSubmitting, isSubmitDisabled, groupedFormsBehaviors, values } =
    useCustomersSettingsPageFormContext();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const { addFormItem } = groupedFormsBehaviors;

  const handleAddLocation = useCallback(
    () => addFormItem(getInitialCreateSubFacilityAddressForm()),
    [addFormItem],
  );

  const handleCancel = useCallback(() => {
    history.push(`/settings/locations/${locationId}/customers`);
  }, [history, locationId]);

  const handleDeleteSuccess = useCallback(() => {
    history.push(`/settings/locations/${locationId}/customers`);
  }, [history, locationId]);

  return (
    <Fragment>
      <AddLocationButton variant="PurpleText" type="button" onClick={handleAddLocation}>
        <BKJIcon iconName="Add" /> {t('location_settings:ADD_CUSTOMER_LOCATION')}
      </AddLocationButton>
      <ActionButtonsWrapper>
        <ActionButton variant="RedText" type="button" onClick={() => setIsDeleteDialogOpen(true)}>
          {t('location_settings:DELETE_CUSTOMER')}
        </ActionButton>
        <Flex width="100%" justifyContent="end" gap="40px">
          <ActionButton variant="PurpleOutlined" type="button" onClick={handleCancel}>
            {t('auth:CANCEL')}
          </ActionButton>
          <ActionButton
            variant="PurpleSolid"
            type="submit"
            isLoading={isSubmitting}
            disabled={isSubmitDisabled}
          >
            {t('auth:SAVE')}
          </ActionButton>
        </Flex>
      </ActionButtonsWrapper>

      <DeleteCustomerDialog
        customerName={values.name}
        isDeleteCustomerConfirmationOpen={isDeleteDialogOpen}
        setIsDeleteCustomerConfirmationOpen={setIsDeleteDialogOpen}
        onSuccess={handleDeleteSuccess}
      />
    </Fragment>
  );
};
